module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "trainRecord"
    }
  }, [(_vm.loading) ? _c('p', {
    staticClass: "u-loading"
  }, [_vm._v("正在加载，请稍候......")]) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "m-result"
  }, [(_vm.showTrain) ? _c('div', {
    staticClass: "trainDate"
  }, [_c('div', {
    staticClass: "date"
  }, [_c('div', {
    staticClass: "dateLabel"
  }, [_c('strong', {
    staticStyle: {
      "color": "#0a81e5"
    }
  }, [_vm._v(_vm._s(this.caseInfo.name))]), _vm._v("  累计训练了\n          "), _c('span', {
    staticStyle: {
      "color": "#0a81e5"
    }
  }, [_vm._v(_vm._s(this.trainDays))]), _vm._v("天；\n          "), _c('span', {
    staticStyle: {
      "color": "#0a81e5"
    }
  }, [_vm._v(_vm._s(this.trainGames))]), _vm._v("个程序；\n          共计"), _c('span', {
    staticStyle: {
      "color": "#0a81e5"
    }
  }, [_vm._v(_vm._s(this.trainTimes))]), _vm._v("局；\n          平均每天"), _c('span', {
    staticStyle: {
      "color": "#0a81e5"
    }
  }, [_vm._v(_vm._s((this.trainTimes / this.trainDays).toFixed(1)))]), _vm._v("局。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('div', {
    staticClass: "dateLabel"
  }, [_vm._v("首次训练日期：" + _vm._s(_vm._f("format")(this.firstDate)))]), _vm._v(" "), _c('div', {
    staticClass: "open-font"
  }, [(_vm.showCalendar) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.showCalendar = false
      }
    }
  }, [_vm._v("收起日历")]) : _c('span', {
    on: {
      "click": function($event) {
        _vm.showCalendar = true
      }
    }
  }, [_vm._v("打开日历")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showCalendar) ? _c('vue-bimonthly-calendar', {
    attrs: {
      "events": _vm.hasVal,
      "selectedDay": _vm.selectedDay
    },
    on: {
      "day-changed": _vm.dateData
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataLists), function(list, index) {
    return _c('div', {
      staticClass: "trainResult"
    }, [_c('div', {
      staticClass: "resultShow"
    }, [_c('ul', {
      staticClass: "resultShow-ul"
    }, [_c('li', {
      staticClass: "oddStyle"
    }, [_vm._v("名称")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(list.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "column-count": "2",
        "width": "200px"
      }
    }, [_c('ul', {
      staticClass: "resultShow-ul",
      staticStyle: {
        "margin-top": "0"
      }
    }, [_c('li', {
      staticClass: "oddStyle",
      staticStyle: {
        "margin-top": "0"
      }
    }, [_vm._v("今日训练次数")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(list.times))])]), _vm._v(" "), _c('ul', {
      staticClass: "resultShow-ul"
    }, [_c('li', {
      staticClass: "oddStyle"
    }, [_vm._v("当前难度")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(("" + (list.currentProgress==0 ? 1:list.currentProgress))))])]), _vm._v(" "), _c('ul', {
      staticClass: "resultShow-ul"
    }, [_c('li', {
      staticClass: "oddStyle"
    }, [_vm._v("训练总时长")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(_vm._f("keepBit")(list.duration)))])]), _vm._v(" "), _c('ul', {
      staticClass: "resultShow-ul"
    }, [_c('li', {
      staticClass: "oddStyle"
    }, [_vm._v("今日最高分")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(list.maxScore))])])]), _vm._v(" "), _c('ul', {
      staticClass: "resultShow-ul"
    }, [_c('li', {
      staticClass: "oddStyle"
    }, [_vm._v("对应脑能力")]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(_vm._f("clean")(list.label)))])]), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "open-font"
    }, [_vm._v("详情"), _c('span', {
      staticStyle: {
        "margin-right": "10px"
      }
    }), _vm._v(" "), (_vm.showIndex != index) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.openDesc(index, list)
        }
      }
    }, [_vm._v("展开")]) : _c('span', {
      on: {
        "click": function($event) {
          _vm.openDesc(-1)
        }
      }
    }, [_vm._v("收起")])]), _vm._v(" "), (_vm.showIndex == index) ? _c('li', {
      staticStyle: {
        "color": "#999"
      }
    }, [(list.trainType == 'cron') ? _c('span', _vm._l((_vm.trainResult), function(res, index) {
      return _c('span', {
        staticStyle: {
          "display": "block",
          "height": "20px"
        }
      }, [(_vm.showSpinner) ? _c('span', [_c('spinner')], 1) : _c('span', [_vm._v("\n                  " + _vm._s(index + 1) + ".开始时间 " + _vm._s(res.start_time) + "，分数：" + _vm._s(res.score) + "，训练时长：" + _vm._s(_vm._f("keepBit")(res.duration))), _c('br')])])
    })) : _c('span', _vm._l((_vm.trainResult), function(res, index) {
      return _c('span', {
        staticStyle: {
          "display": "block",
          "height": "20px"
        }
      }, [(_vm.showSpinner) ? _c('span', [_c('spinner')], 1) : _c('span', [_vm._v("\n                  " + _vm._s(index + 1) + ".开始时间 " + _vm._s(res.start_time) + "，分数：" + _vm._s(res.score) + "，训练时长：" + _vm._s(_vm._f("keepBit")(res.duration)) + "，\n                  "), _vm._v("正确题数/总题数：" + _vm._s(res.corrent_num) + "/" + _vm._s(res.total_num) + "，正确率：" + _vm._s(res.correct_rate) + "%"), _c('br')])])
    }))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "resultChart"
    }, [(_vm.showChart) ? _c('echart', {
      attrs: {
        "name": list.name,
        "date": list.trainDate,
        "index": index,
        "curData": list,
        "chartData": _vm.trainLists
      }
    }) : _vm._e()], 1)])
  })], 2) : _c('div', {
    staticClass: "noTrain"
  }, [_c('span', [_vm._v("暂无训练记录，可点击右上角“现场训练”按钮进行训练")])]), _vm._v(" "), (_vm.showModal) ? _c('trainModal', {
    on: {
      "close": _vm.cancelShow,
      "submitData": _vm.submitCase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTimeTrain) ? _c('timeModalSelect', {
    on: {
      "close": _vm.closeTrain
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveGame) ? _c('trainCronSave', {
    attrs: {
      "gameData": _vm.gameData,
      "gameFlag": 1,
      "caseId": _vm.$route.params.id
    },
    on: {
      "close": _vm.closeGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTimeError) ? _c('zeroLeft', {
    on: {
      "close": function($event) {
        _vm.showTimeError = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date"
  }, [_c('div', {
    staticClass: "dateLabel"
  }, [_vm._v("最近两月出勤情况：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02c901b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/trainRecord/trainRecord.vue
// module id = 938
// module chunks = 2